import { Query, useQuery } from "react-query";
import { DealPartnerContact, Guid } from "../../models";
import { QueryKeys } from '.';
import { useApi } from "../../context";
import { AxiosUtils } from "../../utils";
import { CerebroApiEndpoints } from "../../utils/api";

export function useDataRoomPartnerContactsQuery (guid: Guid | undefined) {
    const api = useApi();
    return useQuery(
        QueryKeys.DataRoomPartnerContacts.Root(guid),
		() => AxiosUtils.getResponseData<DealPartnerContact[]>(api.get(CerebroApiEndpoints.DataRoomPartnerContacts.Contacts(guid))),
		{ enabled: guid !== undefined }
    )
}